module.exports = __webpack_public_path__ + "img/triagle.4ebb38f0.svg";